import React, { useState } from "react";
import { AuthAPI } from "./AuthAPI";
import { Session } from "ywana-core8";

/**
 * Application Context
 */
export const AppContext = React.createContext();

/**
 * Application Context Provider
 */
 export const AppContextProvider = ({ children }) => {

    const [me, setMe] = useState();
    
    async function login(user, password) {
        try {
            const response = await AuthAPI.authenticate(user, password);
            Session.init(response.token, "");
            const me = await AuthAPI.me();
            Session.init(response.token, me);
            setMe(me);
            return me;
        } catch (error) {
            console.log("login error", error);
        }
    }

    const value = {
        me,
        login
    }
    
    return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
